import { property } from 'lodash-es';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- callers merge heterogeneous result types
export const sortByKeyExisting = (arr: any[], key: string): any[][] => {
  const getData = property(key);

  return arr.reduce((acc, curr) => {
    const data = getData(curr);

    if (data) {
      acc[1].push(curr);
    } else {
      acc[0].push(curr);
    }

    return acc;
  }, [[], []]);
};
